import { render, staticRenderFns } from "./SmtpServer.vue?vue&type=template&id=30116554&scoped=true"
import script from "./SmtpServer.vue?vue&type=script&lang=js"
export * from "./SmtpServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30116554",
  null
  
)

export default component.exports